import React, { forwardRef } from 'react';
import { Input } from '../input';
import { useMask } from './use-mask';
/**
 * Компонент `<MaskedInput />` - предоставляет компонент `<Input>` c установленной маской ввода символов.
 *
 * @example ``` tsx
 *  <MaskedInput mask="+7(999)999 99 99" onChange={changeValue} value={value}/>
 * ```
 */

export const MaskedInput = /*#__PURE__*/forwardRef((props, ref) => /*#__PURE__*/React.createElement(Input, { ...useMask(props),
  ref: ref
}));